<div class="page-sub-title">{{ formTitle }}</div>
<form #form="ngForm" class="form">
    <div class="field">
        <input type="text" name="golfCourseName" required [(ngModel)]="createLeagueWeekRequest.golfCourseName" #golfCourseNameModel="ngModel" name="golfCourseName" placeholder=" " />
        <label>Golf Course Name</label>
        <span class="error" *ngIf="golfCourseNameModel.invalid && golfCourseNameModel.touched">
            Golf Course Name is required
        </span>
    </div>

    <div class="field" *ngIf="isLeagueWeek">
        <input
        type="date"
        name="weekStartDate"
        required
        [(ngModel)]="createLeagueWeekRequest.weekStartDate"
        #weekStartDateModel="ngModel"
        />
        <label class="static">Week Start Date</label>
        <span class="error" *ngIf="weekStartDateModel.invalid && weekStartDateModel.touched">
            Week Start Date is required
        </span>
    </div>

    <div class="field" *ngIf="isLeagueWeek">
        <input
        type="date"
        name="weekEndDate"
        required
        [(ngModel)]="createLeagueWeekRequest.weekEndDate"
        #weekEndDateModel="ngModel"
        />
        <label class="static">Week End Date</label>
        <span class="error" *ngIf="weekEndDateModel.invalid && weekEndDateModel.touched">
            Week End Date is required
        </span>
    </div>

    <div class="field">
        <input type="text" name="teeLocation" required [(ngModel)]="createLeagueWeekRequest.teeLocation" #teeLocationModel="ngModel" name="teeLocation" placeholder=" "/>
        <label>Tee Location</label>
        <span class="error" *ngIf="teeLocationModel.invalid && teeLocationModel.touched">
            Tee Location is required
        </span>
    </div>

    <div class="field">
        <input type="text" name="gimmeCircleSize" required [(ngModel)]="createLeagueWeekRequest.gimmeCircleSize" #gimmeCircleSizeModel="ngModel" name="gimmeCircleSize" placeholder=" "/>
        <label>Gimme Circle Size</label>
        <span class="error" *ngIf="gimmeCircleSizeModel.invalid && gimmeCircleSizeModel.touched">
            Gimme Circle Size is required
        </span>
    </div>

    <div class="field">
        <select
            name="pinLocations"
            required
            [(ngModel)]="createLeagueWeekRequest.pinLocations"
            #pinLocationsModel="ngModel"
        >
            <option value="Thursday">Thursday</option>
            <option value="Friday">Friday</option>
            <option value="Saturday">Saturday</option>
            <option value="Sunday">Sunday</option>
        </select>

        <label>Pin Locations</label>

        <span class="error" *ngIf="pinLocationsModel.invalid && pinLocationsModel.touched">
            Pin Locations is required
        </span>
    </div>

    <div class="field">
        <select
            name="holesToPlay"
            required
            [(ngModel)]="createLeagueWeekRequest.holesToPlay"
            #holesToPlayModel="ngModel"
        >
            <option value="FRONT9">Front 9</option>
            <option value="BACK9">Back 9</option>
            <option value="ALL18">All 18</option>
        </select>

        <label>Holes To Play</label>

        <span class="error" *ngIf="holesToPlayModel.invalid && holesToPlayModel.touched">
            Holes to Play is required
        </span>
    </div>

    <div class="field">
        <input type="text" name="coursePar" required [(ngModel)]="createLeagueWeekRequest.coursePar" #courseParModel="ngModel" name="coursePar" placeholder=" "/>
        <label>Course Par</label>
        <span class="error" *ngIf="courseParModel.invalid && courseParModel.touched">
            Course Par is required
        </span>
    </div>

    <div class="field">
        <input type="text" name="roundsToCount" required [(ngModel)]="createLeagueWeekRequest.roundsToCount" #roundsToCountModel="ngModel" name="roundsToCount" placeholder=" "/>
        <label>Number of rounds to count at this course</label>
        <span class="error" *ngIf="roundsToCountModel.invalid && roundsToCountModel.touched">
            Number of rounds to count is required.
        </span>
    </div>
    <div class="field">
        <input type="text" name="maxRoundsToPost" required [(ngModel)]="createLeagueWeekRequest.maxRoundsToPost" #maxRoundsToPostModel="ngModel" name="maxRoundsToPost" placeholder=" "/>
        <label>Max rounds a team/player can post</label>
        <span class="error" *ngIf="maxRoundsToPostModel.invalid && maxRoundsToPostModel.touched">
            Max rounds to post is required.
        </span>
    </div>
</form>
<button (click)="save()">{{ saveLabel }}</button>
<button class="cancel" (click)="cancel()" *ngIf="isEditing">Cancel</button>

